module.exports = __webpack_public_path__ + "static/media/Portrait-Christmas-10039.76cc7574.jpg";